import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { post, get } from "../src/assets/js/tools/request";
import "./plugins/element.js";
import "./assets/js/tools/ht/htconfig";
import md5 from 'js-md5';
import jsPdf from "../src/assets/js/tools/jspdf";
import axios from "axios";
import cookie from 'vue-cookies';
import echarts from 'echarts'
import 'lib-flexible-computer'
import '@/assets/font/font.css'

Vue.config.productionTip = false;

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$md5 = md5;
Vue.prototype.$axios = axios;
Vue.prototype.$cookie = cookie;
Vue.prototype.$echarts = echarts;
Vue.use(jsPdf);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
